import { styled } from "@mui/material/styles";

export const Container = styled("div")(() => ({ theme }) => ({
  display: "flex",
  alignItems: "center",
  background: theme.colors["halt-red-orange"],
  justifyContent: "space-between",
  padding: "14px",
  height: "48px",
  color: theme.colors.white,
  fontSize: "14px",
}));

export const BannerColumn = styled("div")(() => () => ({
  display: "flex",
  alignItems: "center",
}));

export const Text = styled("div")(() => () => ({
  marginLeft: "12px",
}));
